module.exports = __webpack_public_path__ + "static/media/globe-asia.6f749522.svg";